import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: theme.size.base,
    color: '#1F1F1F'
  }
}))

export default useStyles
